import { Injectable, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filter, map, tap } from 'rxjs/operators';
import { setCxbNotification } from '../notification.actions';
import { AppState } from '../notification.reducer';
import { selectCxbNotification } from '../notification.selectors';
import { NotificationColor, NotificationViewModel } from './notification.view-model';

const CANCEL_TIMEOUT = 5000;

@Injectable()
export class NotificationService implements OnDestroy {
  public vm$: Observable<NotificationViewModel>;
  private timer;
  private readonly subscription = new Subscription();

  constructor(private readonly store: Store<AppState>) {
    this.vm$ = this.store.select(selectCxbNotification).pipe(map((notification) => this.mapStateToViewModel(notification)));
    this.subscription.add(
      this.vm$
        .pipe(
          filter((vm) => !!vm.message?.trim()),
          tap(() => this.startTimer())
        )
        .subscribe()
    );
  }

  public cancel(): void {
    this.store.dispatch(setCxbNotification({ message: undefined, color: undefined }));
  }

  private startTimer(): void {
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = setTimeout(() => this.cancel(), CANCEL_TIMEOUT);
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private mapStateToViewModel(notification: { color: NotificationColor; message: string }): NotificationViewModel {
    return {
      message: notification.message,
      color:
        notification.color === NotificationColor.RED
          ? NotificationColor.RED
          : notification.color === NotificationColor.GREEN
          ? NotificationColor.GREEN
          : undefined,
    };
  }
}
